import { Injectable, inject } from '@angular/core';
import { FieldTypeEnum } from '@models/module/fields/enums';
import { ActivityFieldType, BaseFieldValueType } from '@models/module/fields/main';
import { CipoFieldConfig, CipoTextViewConfig, FieldsService } from '@shared/components/fields/common';
import { UtilsService } from '@shared/services';

@Injectable({
  providedIn: 'root',
})
export class GridFormViewService {
  private fieldsService = inject(FieldsService);
  private utilsService = inject(UtilsService);

  getTextViewConfig(
    field: ActivityFieldType,
    includeHistory = false,
  ): {
    config: CipoFieldConfig;
    value: BaseFieldValueType;
    readonlyConfig?: CipoTextViewConfig;
  } {
    const config = this.fieldsService.mapFormFieldModel(field).fieldOptions;
    const { value, readonlyConfig } = this.utilsService.makeValueAndReadonlyConfig(field.oldValue, field.value);
    const sameValue = !!value && !readonlyConfig.oldValue && !readonlyConfig.newValue;

    if (includeHistory && Array.isArray(field.value)) {
      return {
        config,
        value,
        readonlyConfig,
      };
    }

    return {
      config,
      value:
        field.type === FieldTypeEnum.Annotation
          ? field.annotation
          : !includeHistory || sameValue || field.type === FieldTypeEnum.YesNo
            ? (field.value as BaseFieldValueType)
            : undefined,
      readonlyConfig: {
        ...(sameValue || !includeHistory ? {} : readonlyConfig),
        bgColor: field.bgColor,
      },
    };
  }
}
